import {
  form2,
  Input,
  ModalAction,
  ModalComponent,
  ModalComponentRef,
  PayoutPopup,
  removeAbundantSpacesInText,
  Title,
  HeaderTable
} from '@pulseops/common'
import {
  withNumberGreater,
  Label, Row
} from '@pulseops/submission/common'

import * as React from 'react'
import { useTranslation } from 'react-i18next'
import { ScrollView, StyleSheet, useWindowDimensions, View } from 'react-native'
// import { refundCardForm } from './cash-at-counter.form'
import { pipe } from 'fp-ts/function'
import i18next from 'i18next'
import * as t from 'io-ts'
import { withMessage } from 'io-ts-types'
import _ from 'lodash'
import moment from 'moment'
import { Controller } from 'react-hook-form'
import { PolicyType } from '../../../PSSubmissionScreen'
export namespace RefundCardForm {
  const RefundCardform = t.type({
    amount: pipe(
      withMessage(form2.number.required, () =>
        i18next.t('message:MS020001', { field: i18next.t('requestInfo:Amount') })
      ),
      withNumberGreater(0)
    )
  })

  export const codec = RefundCardform

  export type Validated = t.TypeOf<typeof codec>

  export type Raw = t.OutputOf<typeof codec>
}

// let CashAtCounterFormData: CashAtCounterForm.Raw  = {
//   amount: ''
// }

interface Props {
  visible?: boolean
  maxAmount?: number
  onClose?: () => void
  onConfirm?: (payouts: Pick<PayoutPopup.PayoutData, 'amount'>) => void,
  policyInfo?: PolicyType,
}
export type DataSource = {
  [key: string]: string | number | JSX.Element
}
export const RefundCardPopup = ({
  visible,
  maxAmount,
  onClose,
  onConfirm,
  policyInfo,
}: Props) => {
  const { width, height } = useWindowDimensions()
  const { t, i18n } = useTranslation()

  const modalRef = React.useRef<ModalComponentRef | null>(null)

  const refundCardForm = form2.useForm(
    RefundCardForm.codec,
    {
      defaultValues: { amount: 0 }
    },
    'onChange'
  )
  const formData = refundCardForm.base.watch()
  const { amount } = formData

  const onPressClose = () => {
    onClose?.()
  }


  const onPressConfirm = refundCardForm.handleSubmit(async (data) => {
    const amount = Number(formData.amount)
    const payout: Pick<PayoutPopup.PayoutData, 'amount' | 'method' | 'poName' | 'policyNum'> = {
      method: PayoutPopup.PayoutMethods.REFUND_CARD,
      amount: amount,
      policyNum: policyInfo?.policyNum,
      poName: policyInfo?.poName,
    }
    onConfirm?.(payout)
  })

  const modalActions: ModalAction[] = [
    {
      text: t('common:Cancel'),
      type: 'outline',
      action: onPressClose,
      disabled: false,
      loading: false,
      onlyWide: false,
      style: styles.btnCancel
    },
    {
      text: t('submission:Confirm'),
      type: 'filled',
      action: onPressConfirm,
      disabled: !refundCardForm.base.formState.isValid || Number(amount || 0) > maxAmount,
      loading: false,
      onlyWide: false,
      style: styles.btnConfirm
    }
  ]
  return (
    <ModalComponent
      ref={modalRef}
      title={t('submission:RefundCard')}
      titleStyle={styles.modalTitle}
      contentStyle={styles.modalContent}
      modalWidth={Math.min(width * 0.7, 1024)}
      modalHeight={Math.min(height * 0.7, 768)}
      visible={visible}
      onClose={onPressClose}
      actions={modalActions}
    >
      <ScrollView style={styles.container}>
        <Title title={t('submission:RefundCard')} wrapperStyle={styles.bigLabel} />
        <View
          style={{
            flex: 1,
            backgroundColor: '#FAFAFA',
            borderWidth: 1,
            borderColor: '#D3DCE6',
            paddingHorizontal: 30,
            paddingVertical: 22
          }}
        >
          <>
            <Row justifyContent="flex-end" alignItems="center">
              <Label title={`${t('Payout:Currency')}: VND`} fontStyle="italic" />
            </Row>
            <View style={{ flexDirection: 'row', width: '50%' }}>
              <Controller
                control={refundCardForm.base.control}
                name="amount"
                render={({ field, fieldState: { error } }) => (
                  <Input
                    {...field}
                    required={true}
                    title={t('requestInfo:AmountRefund')}
                    containerStyle={{ flex: 1 }}
                    inputType={'money'}
                    value={field.value || ''}
                    errorMessage={Number(field.value || 0) > maxAmount ? t('message:MS050159') : error?.message}
                  />
                )}
              />
            </View>
          </>
        </View>
      </ScrollView>
    </ModalComponent>
  )
}

const styles = StyleSheet.create({
  modalTitle: {
    textAlign: 'center'
  },

  modalContent: {
    backgroundColor: '#EEEEEE'
  },

  btnCancel: {
    height: 39,
    marginEnd: 15
  },

  btnConfirm: {
    height: 39
  },

  container: {
    paddingHorizontal: 30
  },
  label: {
    color: '#70777E',
    fontWeight: 'bold',
    fontSize: 15,
    marginBottom: 2
  },
  searchMessage: {
    color: '#ED1B2C',
    fontSize: 11.25
  },
  bigLabel: {
    textTransform: 'uppercase',
    marginTop: 20,
  },
})
